import axios from 'axios';

// Railway backend URL (used when frontend is on Vercel)
const RAILWAY_API_BASE = 'https://inkoop-software-production.up.railway.app';

function normalizeApiBaseUrl(raw) {
  const trimmed = String(raw || '').trim().replace(/\/+$/, '');
  if (!trimmed) return '';
  if (trimmed.endsWith('/api')) return trimmed;
  return `${trimmed}/api`;
}

// Get API URL from environment variable or use default
const getApiUrl = () => {
  // 1. Check environment variable (voor Vercel/cloud deployment)
  if (process.env.REACT_APP_API_URL) {
    return normalizeApiBaseUrl(process.env.REACT_APP_API_URL);
  }
  
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // 2. Als we op Vercel draaien (inkoop-software.vercel.app of *.vercel.app), gebruik altijd Railway API
  if (hostname.includes('vercel.app') && process.env.NODE_ENV === 'production') {
    return `${RAILWAY_API_BASE}/api`;
  }
  
  // 3. Localhost = development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5000/api';
  }
  
  // 4. Andere production host: probeerzelfde domain (reverse proxy) of fallback Railway
  if (process.env.NODE_ENV === 'production') {
    return `${RAILWAY_API_BASE}/api`;
  }
  
  return 'http://localhost:5000/api';
};

const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 300000, // 5 minuten timeout voor grote imports (was 30 seconden)
  withCredentials: false // JWT tokens gebruiken in plaats van cookies
});

// Request interceptor voor logging (alleen in development)
if (process.env.NODE_ENV === 'development') {
  api.interceptors.request.use(
    (config) => {
      console.log('[API] Request:', config.method?.toUpperCase(), config.url);
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

// Response interceptor voor error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.code === 'ECONNREFUSED' || error.message?.includes('Network Error')) {
      console.error('[API] Connection refused. Is the backend running?');
      console.error('[API] Attempted URL:', error.config?.baseURL);
    }
    return Promise.reject(error);
  }
);

// Add request interceptor to add JWT token to headers
api.interceptors.request.use((config) => {
  // Add JWT token from localStorage
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Don't set Content-Type for FormData (let browser set it with boundary)
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

export default api;
